import { parse } from '@atlassian/cs-ari';

export const parseExtensionId = (extensionId: string) => {
	const ari = parse(extensionId);
	const [appId, environmentId, groupId, moduleKey] = ari.resourceId!.split('/');
	return { appId, environmentId, groupId, moduleKey };
};
